import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  getAgendasBySession,
  createAgenda,
  updateAgenda,
} from "../../services/adminSessionAgendaServices";

const AgendaPage = () => {
  const { sessionId } = useParams();
  const navigate = useNavigate();

  const [agendas, setAgendas] = useState([]);
  const [newAgenda, setNewAgenda] = useState({ title: "", description: "" });
  const [loading, setLoading] = useState(true);

  /* ===============================
     Load Agendas
  =============================== */
  const loadAgendas = async () => {
    try {
      //console.log("🔄 Loading agendas for session:", sessionId);
      setLoading(true);

      const res = await getAgendasBySession(sessionId);
      //console.log("✅ Agendas fetched:", res.data);

      setAgendas(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      //console.error("❌ Failed to load agendas:", err);
      setAgendas([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAgendas();
  }, [sessionId]);

  /* ===============================
     Create Agenda
  =============================== */
  const handleCreateAgenda = async () => {
    if (!newAgenda.title.trim()) {
      //console.warn("⚠️ Agenda title is required");
      return;
    }

    try {
      //console.log("📤 Creating agenda");
      //console.log("Payload:", newAgenda);
      //console.log("Session ID:", sessionId);

      const res = await createAgenda(newAgenda, sessionId);

      //console.log("✅ Agenda created successfully:", res.data);

      setNewAgenda({ title: "", description: "" });

      // reload agendas
      loadAgendas();
    } catch (err) {
      //console.error("❌ Failed to create agenda:", err.response || err);
    }
  };

  /* ===============================
     Update Agenda
  =============================== */
  const handleUpdateAgenda = async (agenda) => {
    if (!agenda.title.trim()) return;

    try {
      //console.log("💾 Updating agenda:", agenda.id);
      await updateAgenda(agenda.id, {
        title: agenda.title,
        description: agenda.description,
      });

      //console.log("✅ Agenda updated:", agenda.id);
      loadAgendas();
    } catch (err) {
      //console.error("❌ Failed to update agenda:", err);
    }
  };

  /* ===============================
     Navigate
  =============================== */
  const handleShowItems = (agendaId) => {
    //console.log("➡️ Navigating to agenda:", agendaId);
    navigate(`/admin/agenda-items/${agendaId}`);
  };

  if (loading) return <p>Loading agendas...</p>;

  return (
    <div style={{ padding: "20px" }}>
      <h3>Session Agendas</h3>

      {/* Create Agenda */}
      <div
        style={{
          marginBottom: "20px",
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: "6px",
        }}
      >
        <h4>Create New Agenda</h4>

        <input
          placeholder="Agenda Title"
          value={newAgenda.title}
          onChange={(e) =>
            setNewAgenda({ ...newAgenda, title: e.target.value })
          }
          style={{ marginRight: "10px" }}
        />

        <input
          placeholder="Description"
          value={newAgenda.description}
          onChange={(e) =>
            setNewAgenda({ ...newAgenda, description: e.target.value })
          }
          style={{ width: "300px", marginRight: "10px" }}
        />

        <button onClick={handleCreateAgenda}>➕ Create Agenda</button>
      </div>

      {/* Agenda List */}
      {agendas.length > 0 ? (
        agendas.map((agenda) => (
          <div
            key={agenda.id}
            style={{
              border: "1px solid #ccc",
              borderRadius: "6px",
              padding: "10px",
              marginBottom: "10px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <input
              value={agenda.title}
              onChange={(e) =>
                setAgendas((prev) =>
                  prev.map((a) =>
                    a.id === agenda.id
                      ? { ...a, title: e.target.value }
                      : a
                  )
                )
              }
              style={{ fontWeight: "bold", flex: 1, marginRight: "10px" }}
            />

            <input
              value={agenda.description || ""}
              onChange={(e) =>
                setAgendas((prev) =>
                  prev.map((a) =>
                    a.id === agenda.id
                      ? { ...a, description: e.target.value }
                      : a
                  )
                )
              }
              style={{ width: "300px", marginRight: "10px" }}
            />

            <button
              onClick={() => handleUpdateAgenda(agenda)}
              style={{ marginRight: "5px" }}
            >
              💾 Save
            </button>

            <button
              onClick={() => handleShowItems(agenda.id)}
              style={{ marginRight: "5px" }}
            >
              📝 Show Items
            </button>
          </div>
        ))
      ) : (
        <p>No agendas found for this session.</p>
      )}

      <button onClick={() => navigate(-1)} style={{ marginTop: "20px" }}>
        ⬅ Back
      </button>
    </div>
  );
};

export default AgendaPage;
